import React, { useState } from 'react';
import Sidebar from './components/Sidebar';
import Dashboard from './components/Dashboard';
import ExploreGraph from './components/ExploreGraph';
import SemanticSearch from './components/SemanticSearch';
import IntelligentSearch from './components/IntelligentSearch';
import AddKnowledge from './components/AddKnowledge';
import AskAtlas from './components/AskAtlas';
import InsightsPanel from './components/InsightsPanel';
import { useEntities } from './hooks/useEntities';

function App() {
  const [currentView, setCurrentView] = useState('dashboard');
  const [recentQueries, setRecentQueries] = useState([
    { id: 1, query: 'What depends on auth-service?', type: 'graph' },
    { id: 2, query: 'Find authentication patterns', type: 'semantic' },
    { id: 3, query: 'Who owns payment-service?', type: 'graph' },
  ]);

  const { entities, relationships, loading, getStatistics } = useEntities();
  const stats = getStatistics();

  const addRecentQuery = (query, type) => {
    setRecentQueries(prev => [
      { id: Date.now(), query, type },
      ...prev.slice(0, 4),
    ]);
  };

  const renderView = () => {
    switch (currentView) {
      case 'dashboard':
        return (
          <Dashboard
            stats={stats}
            entities={entities}
            relationships={relationships}
            loading={loading}
            onNavigate={setCurrentView}
          />
        );
      case 'explore':
        return (
          <ExploreGraph
            entities={entities}
            relationships={relationships}
            loading={loading}
          />
        );
      case 'search':
        return (
          <IntelligentSearch
            onSearch={(query) => addRecentQuery(query, 'semantic')}
          />
        );
      case 'ask':
        return <AskAtlas />;
      case 'add':
        return <AddKnowledge stats={stats} />;
      default:
        return (
          <Dashboard
            stats={stats}
            entities={entities}
            relationships={relationships}
            loading={loading}
            onNavigate={setCurrentView}
          />
        );
    }
  };

  return (
    <div className="flex h-screen bg-dark-900 text-white">
      <Sidebar
        currentView={currentView}
        onNavigate={setCurrentView}
        recentQueries={recentQueries}
      />
      <main className="flex-1 overflow-hidden">
        {renderView()}
      </main>
      <InsightsPanel />
    </div>
  );
}

export default App;
